import { useEffect } from 'react';
/**
 * Registers a global keydown event handler.
 *
 * If you find yourself checking the event target, it may be better to attach the
 * event handler directly on that element.
 */
export function useKeyDown(callbacks) {
    useEffect(function () {
        if (Object.keys(callbacks).length === 0) {
            return;
        }
        var handleKeyDown = function (e) {
            if (callbacks.hasOwnProperty(e.key)) {
                callbacks[e.key](e);
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return function () { return window.removeEventListener('keydown', handleKeyDown); };
    }, [callbacks]);
}
//# sourceMappingURL=useKeyDown.js.map